/**
 * Remove the previous transaction id from local storage before going to
 * order page when clicking the proceed to checkout button
 */
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('proceed-to-checkout')) {
    e.preventDefault();
    localStorage.removeItem('transaction_id');
    window.location.href = '/order';
  }
});
